<template>
    <div class="modal fade favourite-item-modal custom-modal" id="edit_notes_favourite_item_modal" tabindex="-1" role="dialog" aria-hidden="true" data-keyboard="false">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-content custom-modal-content">
                    <div class="modal-header custom-modal-header">
                        <i class="fad fa-star"></i>
                        <h5 class="modal-title"> Modifica notite </h5>
                    </div>
                    <div class="dismiss-modal-btn" data-dismiss="modal" aria-label="Close">
                        <i class="fad fa-times-circle"></i>
                    </div>
                    <div class="modal-body custom-modal-body">
                        <div class="create-message-container">
                            <div class="input-container">
                                <div class="input-group mg-b">
                                    <textarea name="description" v-model="notes" id="favrourite_item_note" placeholder="Scrie o notita...(optional)"></textarea>
                                    <div class="input-icon">
                                        <i class="fad fa-comment-alt-lines"></i>
                                    </div>
                                    <label class="custom-label" for="favrourite_item_note"> Notita </label>
                                </div>
                                <p class="custom-input-error"></p>
                            </div>
                            <div class="center-content mt-3">
                                <button type="button" name="button" class="general-btn positive-btn" @click="save()">
                                    <i class="fad fa-paper-plane"></i>
                                    <span> Salveaza </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "EditNotesFavoriteModal",
    data() {
        return {
            localFavorite: null,
            notes: null,
            favoriteItem: null
        }
    },
    mounted() {
        let vm = this
        $('#edit_notes_favourite_item_modal').on('hidden.bs.modal', function () {
            vm.favoriteItem = null
            vm.notes = null
        });
        this.$eventBus.$on('OPEN_EDIT_NOTES_FAV_MODAL', function (payLoad) {
            vm.getFavoriteItem(payLoad.id)
            vm.localFavorite = false;
            $('#edit_notes_favourite_item_modal').modal('show')
        });
        this.$eventBus.$on('OPEN_EDIT_NOTES_LOCAL_FAV_MODAL', function (payLoad) {
            // console.log('OPEN_EDIT_NOTES_LOCAL_FAV_MODAL',payLoad.favorite);
            vm.localFavorite = true;
            vm.favoriteItem = payLoad.favorite;
            vm.notes = payLoad.favorite ? payLoad.favorite.notes : null;
            $('#edit_notes_favourite_item_modal').modal('show')
        });
    },
    methods: {
        save() {
            let vm = this
            if(!vm.localFavorite) {
                this.triggerLoader(true)
                window.axios.post(`/ajax/edit-favorite-notes/${this.favoriteItem.id}`, {
                    notes: this.notes
                })
                    .then(function (response) {
                        window.Swal.fire({
                            position: 'top-end',
                            icon: 'success',
                            html: 'Notitele au fost modificate cu succes.',
                            showConfirmButton: false,
                            timer: 1500
                        })
                        vm.id = vm.notes = vm.localFavorite = null;
                        $('#edit_notes_favourite_item_modal').modal('hide')
                        vm.$eventBus.$emit('FAVORITE_NOTES_CHANGED', {
                            fav: response.data.data
                        });
                        vm.triggerLoader(false)
                    })
                    .catch(function (err) {
                        window.showError(err)
                        vm.triggerLoader(false)
                    });
            } else if(vm.favoriteItem) {
                let localFavorites = window.getLocalFavorites();
                let localFavorite = localFavorites.find(favorite => favorite.favoritable_type == vm.favoriteItem.favoritable_type && favorite.favoritable_id === vm.favoriteItem.favoritable_id);
                localFavorite.notes = this.notes;
                window.saveLocalFavorites(localFavorites);
                vm.id = vm.notes = vm.localFavorite = null;
                $('#edit_notes_favourite_item_modal').modal('hide')
                vm.$eventBus.$emit('LOCAL_FAVORITE_NOTES_CHANGED', {
                    favorite: localFavorite
                });
            }
        },
        getFavoriteItem(id) {
            let vm = this
            this.triggerLoader(true)
            window.axios.get(`/ajax/get-favorite-item/${id}`)
                .then(function (response) {
                    vm.favoriteItem = response.data.data
                    vm.notes = response.data.data.notes
                    vm.triggerLoader(false)
                })
                .catch(function () {
                    vm.triggerLoader(false)
                    $('#edit_notes_favourite_item_modal').modal('hide')
                });
        }
    }
}
</script>

<style scoped>

</style>
